.wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5;
  padding: 4px 20px 32px;
  background: linear-gradient(to bottom, rgba(255, 251, 242, 0) 0%, #fffbf2 32.292%);
  max-width: 450px;
  margin: 0 auto;
}

.button {
  width: 100%;
  height: 60px;
  background: var(--ed-brand, #ae66f6);
  border: none;
  border-radius: 48px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fffbf2;
  font-size: 22px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0.088px;
  position: relative;
  text-transform: lowercase;
  transition: background 0.2s;

  p {
    margin: 0;

    &::first-letter {
      text-transform: capitalize;
    }
  }

  &:hover {
    background: var(--ed-brand, #9d50d5);
  }

  &:active {
    background: var(--ed-brand, #7d39ae);
  }
}

.arrow {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  object-fit: contain;
}
